import axios from "./_axios";
import { API } from "./apiEndPoints";

/**
 * List tasks for an account (ER-11187 generic Task list API).
 *
 * Endpoint: GET /api/proficiency/v2/account/{account_id}/tasks/
 *
 * Supported query params (backed by TaskV2ViewSet):
 *  - assignee=me  -> the authenticated user's tasks
 *  - search=...   -> case-insensitive substring match on summary only
 *  - status=...   -> comma-separated status values (PENDING, COMPLETED, CANCELLED)
 *  - ordering=... -> id | deadline | status | priority (prefix - for desc)
 *  - limit/offset -> pagination (default 20, max 100)
 *
 * @param {number|string} account_id
 * @param {object} [params]
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export const getAccountTasks = (account_id, params = {}) => {
  return axios()({
    method: "get",
    url: `${API.TASKS}${account_id}/tasks/`,
    params,
  });
};

/**
 * Retrieve a single task in an account.
 *
 * Endpoint: GET /api/proficiency/v2/account/{account_id}/tasks/{task_id}/
 *
 * @param {number|string} account_id
 * @param {number|string} task_id
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export const getAccountTask = (account_id, task_id) => {
  return axios()({
    method: "get",
    url: `${API.TASKS}${account_id}/tasks/${task_id}/`,
  });
};
